import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Mail, Phone, MapPin } from "lucide-react";
import footerLogo from "@/assets/footer-logo.png";
const Footer = React.forwardRef<HTMLElement, React.HTMLAttributes<HTMLElement>>((props, ref) => {
  return <footer ref={ref} className="bg-secondary text-secondary-foreground" {...props}>
        <div className="container mx-auto px-4 py-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Campaign Info */}
            <div>
              <img alt="Matt Bucher for State Representative" className="h-28 w-auto mb-4" src="/lovable-uploads/99d5ab1a-5919-4395-8109-cb67912397d5.jpg" />
              <div className="flex gap-4">
                <a href="https://www.facebook.com/profile.php?id=100077991582201" target="_blank" rel="noopener noreferrer" className="text-secondary-foreground/80 hover:text-secondary-foreground transition-colors" aria-label="Visit Matt Bucher Campaign on Facebook">
                  <Facebook className="h-5 w-5" aria-hidden="true" />
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="font-display text-lg font-bold mb-4">Quick Links</h4>
              <nav className="flex flex-col gap-2" aria-label="Footer navigation">
                <Link to="/issues" className="font-body text-secondary-foreground/80 hover:text-secondary-foreground transition-colors">
                  Issues
                </Link>
                <Link to="/about" className="font-body text-secondary-foreground/80 hover:text-secondary-foreground transition-colors">
                  About Matt
                </Link>
                <Link to="/news" className="font-body text-secondary-foreground/80 hover:text-secondary-foreground transition-colors">
                  News
                </Link>
                <Link to="/volunteer" className="font-body text-secondary-foreground/80 hover:text-secondary-foreground transition-colors">
                  Volunteer
                </Link>
                <Link to="/donate" className="font-body text-secondary-foreground/80 hover:text-secondary-foreground transition-colors">
                  Donate
                </Link>
              </nav>
            </div>

            {/* Contact */}
            <div>
              <h4 className="font-display text-lg font-bold mb-4">Contact Us</h4>
              <address className="flex flex-col gap-3 not-italic">
                <a className="flex items-center gap-2 font-body text-secondary-foreground/80 hover:text-secondary-foreground transition-colors" href="mailto:info@votebucher.com">
                  <Mail className="h-4 w-4" aria-hidden="true" />
                  info@votebucher.com
                </a>
                <a className="flex items-center gap-2 font-body text-secondary-foreground/80 hover:text-secondary-foreground transition-colors" href="tel:+13024621962">
                  <Phone className="h-4 w-4" aria-hidden="true" />
                  (302) 462-1962 
                </a>
                <div className="flex items-start gap-2 font-body text-secondary-foreground/80">
                  <MapPin className="h-4 w-4 mt-1 flex-shrink-0" aria-hidden="true" />
                  <span>114 Woodview Drive<br />Harrington, DE 19952</span>
                </div>
              </address>
            </div>
          </div>

          <div className="border-t border-secondary-foreground/20 mt-8 pt-8 text-center">
            <p className="font-body text-sm text-secondary-foreground/60">
              © {new Date().getFullYear()} Matt Bucher for State Representative. All rights reserved.
            </p>
            <p className="font-body text-xs text-secondary-foreground/50 mt-2">
              Paid for by Friends of Matt Bucher
            </p>
          </div>
        </div>
      </footer>;
});
Footer.displayName = "Footer";
export default Footer;